import { IModalsConfig } from './../modals.config.interface';

export const STUDENT_PATHS_MODAL_CONFIG: IModalsConfig = {
  input: {
    placeholder: 'Find a college...',
  },
  buttons: {
    confirm: {
      text: 'Add College',
      disableButtonRipple: true,
    },
    cancel: {
      text: 'Cancel',
      disableButtonRipple: true,
    },
  },
};
